export enum RiskStandingDataType {
    Unknown = 0,
    RiskCatalogues = 1,
    RiskOwners = 5,
    BusinessDimensions = 6,
    FrameworkDimensions = 7,
    RiskInformeds = 8,
}
